var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React from 'react';
import classnames from 'classnames';
import { nxVulnerabilityIndicatorLegendPropTypes } from './types';
import NxVulnerabilityIndicator from '../NxVulnerabilityIndicator/NxVulnerabilityIndicator';
import './NxVulnerabilityIndicatorLegend.scss';
var capitalize = function (str) { return str.charAt(0).toUpperCase() + str.slice(1); };
var VulnerabilityIndicator = function (_a) {
    var severityRating = _a.severityRating;
    return (React.createElement("div", { className: "nx-vulnerability-indicator-legend__vulnerability-container" },
        React.createElement(NxVulnerabilityIndicator, { severityRating: severityRating }),
        React.createElement("span", null, capitalize(severityRating))));
};
export default function NxVulnerabilityIndicatorLegend(props) {
    var critical = props.critical, high = props.high, medium = props.medium, low = props.low, none = props.none, vertical = props.vertical, header = props.header, className = props.className, attrs = __rest(props, ["critical", "high", "medium", "low", "none", "vertical", "header", "className"]);
    var classNames = classnames(className, 'nx-vulnerability-indicator-legend', {
        'nx-vulnerability-indicator-legend--vertical': vertical
    });
    if (!critical && !high && !medium && !low && !none) {
        console.warn("No vulnerability severity rating for NxVulnerabilityIndicatorLegend have been provided\n    as props so nothing will be rendered.");
        return null;
    }
    return (React.createElement("div", __assign({ className: classNames }, attrs),
        React.createElement("label", { className: "nx-vulnerability-indicator-legend__header" }, header || 'Legend'),
        critical && React.createElement(VulnerabilityIndicator, { severityRating: "critical" }),
        high && React.createElement(VulnerabilityIndicator, { severityRating: "high" }),
        medium && React.createElement(VulnerabilityIndicator, { severityRating: "medium" }),
        low && React.createElement(VulnerabilityIndicator, { severityRating: "low" }),
        none && React.createElement(VulnerabilityIndicator, { severityRating: "none" })));
}
NxVulnerabilityIndicatorLegend.propTypes = nxVulnerabilityIndicatorLegendPropTypes;
export { nxVulnerabilityIndicatorLegendPropTypes } from './types';
//# sourceMappingURL=NxVulnerabilityIndicatorLegend.js.map